import React from 'react';
import CargoNameAutoComplete from '../../../../common/CargoAutoComplete';

export default function CargoName({ cargo, updateField }) {
    return (
        <CargoNameAutoComplete 
            item={cargo}
            _preventFirstSearch
            updateItem={value => updateField('cargo', value)}
            style={{ display: 'flex' }}
        />
    );
}



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Hire/content/CargoName.jsx